import type { NavLink } from "../../shared/types/navigation";

export const profileNavLinks: NavLink[] = [
  { label: "プロフィール", href: "#about" },
  { label: "スキル", href: "#skills" },
  { label: "個人開発", href: "#featured-projects" },
  { label: "実績", href: "#projects" },
];
